import { render, staticRenderFns } from "./BatchPackagingSelect.vue?vue&type=template&id=0b7ed814&scoped=true"
import script from "./BatchPackagingSelect.vue?vue&type=script&lang=js"
export * from "./BatchPackagingSelect.vue?vue&type=script&lang=js"
import style0 from "./BatchPackagingSelect.vue?vue&type=style&index=0&id=0b7ed814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ed814",
  null
  
)

export default component.exports